__turbopack_context__.v({
  "frameBox": "hero-module__AxRrtq__frameBox",
  "stage": "hero-module__AxRrtq__stage",
});
